// AUTO-GENERATED by scripts/generate-placeholder-art.ts — do not edit by hand.
// Source of truth: art/prompts/style-pack.md (Bothy 20 style anchor),
// cross-checked against art/source/bothy-20.json. Re-run `npm run gen-art`
// after either of those files change.

export const PALETTE = {
  DEEP_PLUM: '#2a2140',
  MIDNIGHT_PURPLE: '#3b3772',
  ROYAL_BLUE: '#434ea8',
  SOFT_VIOLET: '#735bab',
  LAVENDER: '#ab7ac6',
  PINK_BLOOM: '#e1a7c5',
  SKY_BLUE: '#759ed0',
  ICE_BLUE: '#a2dceb',
  SNOW_WHITE: '#dfffff',
  MINT_GREEN: '#b5de89',
  FOREST_GREEN: '#6aab7c',
  TEAL_SHADOW: '#26616b',
  CRIMSON: '#ab2330',
  CORAL_RED: '#da5e4e',
  PEACH: '#eb9361',
  HONEY_GOLD: '#ffd887',
  DARK_BROWN: '#4a2c2a',
  CHESTNUT: '#7a4a3a',
  TAN: '#b07a52',
  CREAM: '#f3e3c3',
} as const;

export type PaletteName = keyof typeof PALETTE;

/** Convert one of our '#rrggbb' hex strings to a Phaser-friendly 0xRRGGBB number. */
export function paletteNumber(hex: (typeof PALETTE)[PaletteName]): number {
  return parseInt(hex.replace('#', ''), 16);
}
